import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import RedirectIfAuthenticated from './components/RedirectIfAuthenticated';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Layout from './pages/Layout';
import Settings from './pages/Settings';
import Booking from './pages/Mobility/Booking';
import Payment from './pages/Mobility/Payment';
import BookingConfirmationPage from './pages/BookingConfirmationPage';
import { useAuth } from './contexts/AuthContext';
import DefaultRedirect from './components/DefaultRedirect';
import AdminRoute from './components/AdminRoute';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<DefaultRedirect />} />
          <Route path="/signin" element={<RedirectIfAuthenticated><Login /></RedirectIfAuthenticated>} />
          <Route path="/signup" element={<RedirectIfAuthenticated><Signup /></RedirectIfAuthenticated>} />
          <Route path="/dashboard" element={<AdminRoute><Layout /></AdminRoute>} />
          <Route path="/users" element={<AdminRoute><Layout /></AdminRoute>} />
          <Route path="/communication" element={<AdminRoute><Layout /></AdminRoute>} />
          {/* Anciennes sections « Notifications » et « Marketing », fusionnées dans Communication. */}
          <Route path="/notifications" element={<Navigate to="/communication?vue=push" replace />} />
          <Route path="/marketing" element={<Navigate to="/communication" replace />} />
          {/* Ancienne section « E-mails », aujourd'hui onglet de Communication. */}
          <Route path="/emails" element={<Navigate to="/communication?vue=emails" replace />} />
          <Route path="/support" element={<AdminRoute><Layout /></AdminRoute>} />
          <Route path="/journaux" element={<AdminRoute><Layout /></AdminRoute>} />
          {/* Anciennes sections « Journal » et « Journaux API », fusionnées dans Journaux. */}
          <Route path="/audit-log" element={<Navigate to="/journaux?vue=historique" replace />} />
          <Route path="/api-logs" element={<Navigate to="/journaux" replace />} />
          {/* Sans cette ligne, le clic sur « Vérifications » tombait sur le
              filet `path="*"` et renvoyait à l'accueil : l'entrée de menu et
              l'écran existaient, la route non. */}
          <Route path="/verifications" element={<AdminRoute><Layout /></AdminRoute>} />
          {/* Ouverte par « Voir tout » depuis la cloche. Absente de la barre
              latérale : la cloche est son point d'entrée naturel, et une
              entrée de plus n'aiderait pas une navigation déjà chargée. */}
          <Route path="/a-traiter" element={<AdminRoute><Layout /></AdminRoute>} />
          <Route path="/analytics" element={<AdminRoute><Layout /></AdminRoute>} />
          <Route path="/frais" element={<AdminRoute><Layout /></AdminRoute>} />
          <Route path="/promo-codes" element={<AdminRoute><Layout /></AdminRoute>} />
          <Route path="/mytrips" element={<AdminRoute><Layout /></AdminRoute>} />
          <Route path="/myrentals" element={<AdminRoute><Layout /></AdminRoute>} />
          <Route path="/overview" element={<ProtectedRoute><Layout /></ProtectedRoute>} />
          <Route path="/user" element={<ProtectedRoute><Layout /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Layout /></ProtectedRoute>} />
          <Route path="/booking" element={<ProtectedRoute><Booking /></ProtectedRoute>} />
          <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
          <Route path="/booking-confirmation" element={<ProtectedRoute><BookingConfirmationPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
